export const DUPLICATE_VERIFICATION = 22007;
export const DUPLICATE_CANCEL_VERIFICATION = 22012;
export const ERROR_ACCOUNT_NOT_EXIST = 2000;
export const ERROR_EMAIL_EXPIRED = 5007;
export const ERROR_RECORD_NOT_FOUND = 1001;
export const TEMP_REPORT_EXPIRED = 32000;

export default {};
